export const getInitialValue = ({ name }) => ({
  name: name || '',
})
